import React from 'react'
import { SVGIconProps } from '../types'
const SvgViewCarousel = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M7 19h10V4H7zm-5-2h4V6H2zM18 6v11h4V6z" />
  </svg>
)
export default SvgViewCarousel
